<template>
  <div class="question-edit">

    <div class="flex-fill">

      <wysiwyg v-model="innerModel.text" />
      <div class="d-flex">
        <div class="flex-fill p-2">
          <media-preview v-if="media" v-model="media" style="margin:0 auto" @click="selectMedia = true" />
        </div>

        <div class="nowrap p-2">
          <media-picker :tenant-id="organization.id" :module-id="module.id" :current="media" link-text="media library"
                        @selected="onMediaSelected" @remove="onMediaRemoved" />
        </div>
      </div>
      <br />
      <div>
        <label>Choices</label>
        <select v-model="innerModel.type">
          <option value="radio">Single Choice</option>
          <option value="checkbox">Multiple Choice</option>
        </select>
      </div>

      <choices v-model="innerModel" />

    </div>

    <div class="text-center">
      <b-button @click.stop="cancel()">Cancel</b-button>
      <b-button :disabled="disableSave" variant="primary" @click.stop="save()">Save</b-button>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import {mapState} from 'vuex'
import api from '@/api/knowledgechecks/questions.js'

import draggable from 'vuedraggable'
import mediaPicker from '../media/mediaPicker.vue'
import mediaPreview from '@/components/common/media/media-preview'
import choices from './choices'

export default {
  components: {
    choices,
    draggable,
    mediaPreview,
    mediaPicker
  },
  props: {
    value: {type:null, default: ''},
    knowledgecheck: {type: Object, required: true}
  },
  data(){
    return{
      componentId: null,
      editChoice: null,
      innerModel: {},
      media: null
    }
  },
  computed: {
    ...mapState('tenants', {
      organization: 'current'
    }),
    ...mapState('modules', {
      module: 'current'
    }),
    choices(){
      return this.innerModel.choices
    },
    inputType(){
      return this.innerModel.type
    },
    radioSelected:{
      get(){ return _.findIndex(this.innerModel.choices, 'is_answer') },
      set(value){
        if(this.inputType != 'radio') {
          return
        }
        _.each(this.innerModel.choices, (c) => {c.is_answer = false})
        this.innerModel.choices[value].is_answer = true }
    },
    disableSave(){
      if(!this.innerModel.choices ||  this.innerModel.choices.length < 2){
        return true
      }

      const answers = _.find(this.innerModel.choices, (c) => {return c.is_answer })
      if(!answers){
        return true
      }

      return false
    }
  },
  watch: {
    value(val){
      if(val != this.innerModel){
        this.innerModel = _.cloneDeep(val)
        this.media = this.innerModel.media
      }
    },
    inputType(val, oldVal){
      if(oldVal){
        _.each(this.innerModel.choices, (c) => {c.is_answer = false})
      }
    }
  },
  mounted(){
    this.componentId = this._uid
    this.innerModel = _.cloneDeep(this.value)
    this.innerModel.choices.sort((a, b) => (a.order > b.order) ? 1 : -1)
    this.media = this.innerModel.media
  },
  methods:{
    onDragEnd(evt){
      _.each(this.innerModel.choices, (c, i) => (c.order = i))
    },
    addChoice(){
      const order = this.innerModel.choices.length + 1
      const value = `new choice ${  order}`

      this.innerModel.choices.push({
        label: value,
        order: order,
        value: value
      })
    },
    edit(choice){
      this.editChoice = choice
    },
    removeAt(idx) {
      this.innerModel.choices.splice(idx, 1)
    },
    addMedia(){
      alert('coming soon')
    },
    async save(){
      const params = {
        tenantId: this.organization.id,
        knowledgecheckId: this.knowledgecheck.id,
        data: this.innerModel
      }

      if(!this.innerModel.id){
        const response = await api.store(params)
        this.innerModel.id = response.data.data.id
      }
      else{
        params.questionId = this.innerModel.id
        await api.update(params)
      }
      this.innerModel.media = this.media
      this.$emit('saved', this.innerModel)
    },
    cancel(){
      this.$emit('canceled', this.innerModel)
    },
    onMediaSelected(media){
      this.media = media
      this.innerModel.media_id = media.id
    },
    onMediaRemoved(){
      this.media = null
      this.innerModel.media_id =null
      this.innerModel.media = null
    }
  }
}
</script>

<style lang="scss" scoped>
.question-edit {
    padding: 0 5px;
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/knowledge-checks/questions/edit.vue